import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from "./components/HelloWorld.vue";
import Detail from "./components/Detail.vue";
import Index from "./components/Index.vue";
import Studio from "./components/Studio.vue";
import StudioImage from "./components/StudioImage.vue";
import Images from "./components/Images.vue";
import NewIndex from "./components/NewIndex.vue";
import NewStudio from "./components/NewStudio.vue";
import NewStudioImage from "./components/NewStudioImage.vue";
import NewImages from "./components/NewImages.vue";
// import Images2 from "./components/Images2.vue";
// import Images3 from "./components/Images3.vue";
// import Images4 from "./components/Images4.vue";
import SplashPage from "@/components/SplashPage";
import NewSplashPage from "@/components/NewSplashPage";
import ProjectList from "@/components/ProjectList";
import ProjectDetail from "@/components/ProjectDetail";
import Swipe from "@/components/Swipe";

import VueMq from "vue-mq";

Vue.use(VueMq, {
    breakpoints: {
        mobile: 768,
        desktop: Infinity
    }
});

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "home",
            component: SplashPage
        },
        {
            path: "/projects/",
            name: "detail",
            component: Detail
        },
        {
            path: "/projects/:slug",
            name: "detail-slug",
            component: Detail
        },
        {
            path: "/projects/:slug/:id",
            name: "detail-image",
            component: Detail
        },
        {
            path: "/index-text",
            name: "index",
            component: Index
        },
        {
            path: "/about-text",
            name: "studio",
            component: Studio
        },
        {
            path: "/about-image",
            name: "studio-image",
            component: StudioImage
        },
        {
            path: "/index-image",
            name: "images",
            component: Images
        },
        {
            path: "/dev/slideshow",
            name: "swipe",
            component: Swipe
        },
        {
            path: "/dev/slideshow/:slug",
            name: "swipe-slug",
            component: Swipe
        },
        {
            path: "/dev/slideshow/:slug/:id",
            name: "swipe-image",
            component: Swipe
        },
        {
            path: "/dev/index-text",
            name: "index-dev",
            component: NewIndex
        },
        {
            path: "/dev/index-image",
            name: "images-dev",
            component: NewImages
        },
        {
            path: "/dev/about-text",
            name: "studio-dev",
            component: NewStudio
        },
        {
            path: "/dev/about-image",
            name: "studio-image-dev",
            component: NewStudioImage
        },
        {
            path: "/dev/",
            name: "splash-dev",
            component: NewSplashPage
        },

        {
            path: "/dev/projects",
            redirect: { name: "project-list-books" }
        },
        {
            path: "/dev/projects/publications",
            name: "project-list-books",
            component: ProjectList
        },
        {
            path: "/dev/projects/websites",
            name: "project-list-websites",
            component: ProjectList
        },
        {
            path: "/dev/projects/typefaces",
            name: "project-list-typefaces",
            component: ProjectList
        },
        {
            path: "/dev/projects/identities",
            name: "project-list-identities",
            component: ProjectList
        },
        {
            path: "/dev/projects/:slug",
            name: "project-detail",
            component: ProjectDetail
        },
        {
            path: "/splash",
            name: "splash",
            component: SplashPage
        }

        //{
        //path: '/images2',
        //name: 'images2',
        //component: Images2
        //},
        //{
        //path: '/images3',
        //name: 'images3',
        //component: Images3
        //},
        //{
        //path: '/images4',
        //name: 'images4',
        //component: Images4
        //},
    ]
});
